

export enum ShopItemReservationType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
};
